/* src/app/modules_v2/investment/real-state-investment/components/real-state-investment-detail/real-state-investment-detail.component.scss */
:host {
  display: block;
}
.rd-panel {
  display: grid;
  grid-template-columns: minmax(280px, 1fr) minmax(0, 1.4fr);
  gap: 16px;
}
.rd-card {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 14px 16px;
  min-width: 0;
}
.rd-card__header,
.rd-block__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}
.rd-block__header {
  margin-bottom: 8px;
}
.rd-card__title,
.rd-block__title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 700;
  color: #1a1d23;
  min-width: 0;
}
.rd-card__title mat-icon,
.rd-block__title mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  color: #6b7280;
  flex-shrink: 0;
}
.rd-block__count {
  font-size: 12px;
  font-weight: 600;
  color: #6b7280;
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
}
.rd-progress__bar {
  height: 8px;
  border-radius: 999px;
  background: #eef1f4;
  overflow: hidden;
}
.rd-progress__fill {
  height: 100%;
  border-radius: 999px;
  background: #c5d94a;
  transition: width 0.3s ease;
}
.rd-progress__legend {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 6px;
  font-size: 12px;
  color: #6b7280;
}
.rd-progress__legend strong {
  color: #1a1d23;
  font-variant-numeric: tabular-nums;
}
.rd-kpis {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
  margin-top: 12px;
}
.rd-kpis--compact {
  margin-top: 8px;
}
.rd-kpi {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 8px 10px;
  background: #f4f6f8;
  border-radius: 8px;
  min-width: 0;
}
.rd-kpi--accent {
  background: #fbfee8;
  border: 1px solid #e5f3a0;
}
.rd-kpi__label {
  font-size: 11px;
  color: #6b7280;
}
.rd-kpi__value {
  font-size: 14px;
  font-weight: 700;
  color: #1a1d23;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.rd-lines {
  display: flex;
  flex-direction: column;
  margin-top: 12px;
  border: 1px solid #eef1f4;
  border-radius: 8px;
  overflow: hidden;
}
.rd-line {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 7px 12px;
  font-size: 13px;
  color: #2f3540;
}
.rd-line + .rd-line {
  border-top: 1px solid #eef1f4;
}
.rd-line__label {
  flex-shrink: 0;
}
.rd-line__value {
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: right;
}
.rd-card__title {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.rd-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}
.rd-block {
  padding: 10px 0;
}
.rd-block + .rd-block {
  border-top: 1px solid #eef1f4;
}
.rd-block__side {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
}
.rd-block__summary {
  font-size: 12px;
  color: #6b7280;
  white-space: nowrap;
}
.rd-block__summary strong {
  color: #1a1d23;
  font-variant-numeric: tabular-nums;
}
.rd-add.cf-btn.mat-mdc-button-base {
  height: 28px !important;
  padding: 0 10px !important;
  font-size: 12px !important;
}
.rd-add.cf-btn.mat-mdc-button-base .mat-icon {
  font-size: 16px !important;
  width: 16px !important;
  height: 16px !important;
  margin-right: 2px !important;
}
.rd-moves {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.rd-move {
  display: grid;
  grid-template-columns: 90px minmax(0, 1fr) auto auto;
  align-items: center;
  gap: 10px;
  padding: 6px 6px 6px 10px;
  background: #f9fafb;
  border: 1px solid #eef1f4;
  border-radius: 6px;
  font-size: 13px;
  transition: border-color 0.15s ease, background 0.15s ease;
}
.rd-move:hover {
  background: #fff;
  border-color: #e5e7eb;
}
.rd-move__date {
  color: #6b7280;
  white-space: nowrap;
}
.rd-move__info {
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.rd-move__concept,
.rd-move__meta {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.rd-move__concept {
  color: #2f3540;
}
.rd-move__meta {
  font-size: 11px;
  color: #6b7280;
}
.rd-move__amount {
  font-weight: 700;
  color: #1a1d23;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}
.rd-move__actions {
  display: flex;
  align-items: center;
  gap: 2px;
}
.rd-icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: #9ca3af;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
}
.rd-icon-btn mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.rd-icon-btn:hover {
  background: #f3f4f6;
  color: #1a1d23;
}
.rd-icon-btn--danger:hover {
  background: #fef2f2;
  color: #dc2626;
}
.rd-more {
  display: inline-flex;
  align-items: center;
  align-self: flex-start;
  gap: 2px;
  margin-top: 2px;
  padding: 2px 6px;
  border: 0;
  border-radius: 6px;
  background: transparent;
  font-size: 12px;
  font-weight: 600;
  color: #4b5563;
  cursor: pointer;
}
.rd-more mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
}
.rd-more:hover {
  background: #f3f4f6;
  color: #1a1d23;
}
.rd-block__empty {
  font-size: 12px;
  color: #9ca3af;
  padding: 2px 0;
}
.rd-empty {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  padding: 12px 14px;
  background: #f9fafb;
  border: 1px dashed #e5e7eb;
  border-radius: 8px;
  font-size: 13px;
  color: #6b7280;
}
.rd-empty mat-icon {
  flex-shrink: 0;
  font-size: 20px;
  width: 20px;
  height: 20px;
}
.rd-empty--error mat-icon {
  color: #dc2626;
}
@media (max-width: 900px) {
  .rd-panel {
    grid-template-columns: 1fr;
  }
  .rd-kpis {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 480px) {
  .rd-move {
    grid-template-columns: minmax(0, 1fr) auto auto;
  }
  .rd-move__date {
    grid-column: 1/-1;
  }
}
/*# sourceMappingURL=real-state-investment-detail.component.css.map */
